type DeviceType = 'touched' | 'cursorBased';

export const getDeviceType = () => {
  let deviceType: DeviceType;
  if (window.matchMedia('(pointer: coarse)').matches) {
    deviceType = 'touched';
  } else {
    deviceType = 'cursorBased';
  }
  return deviceType;
};
